/* eslint-disable import/no-named-default */
import angular from 'angular';
import constants from 'app/constants';
import {
  docDataService,
  loaderService,
  oversightDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
// import { default as docDataService } from 'app/services/data/doc.data.service';
import addAgendaItemNoteDialog from '../dialog.addAgendaItemNoteDialog';
import attachAgendaItemDialog from '../dialog.attachAgendaItemDialog';
import agendaItemComment from '../agendaItemComment';
import agendaItemReport from '../agendaItemReport';
import agendaItemDocument from '../agendaItemDocument';
import agendaItemFollowup from '../agendaItemFollowup';
import controller from './edit-agendaItem-dialog.controller';
import template from './edit-agendaItem-dialog.html';
import agendaItemCompleteDateMessagesTpl from '../../../messages/agenda-item-complete-date.messages.html';

class dialogService {
  getOptions($event, {
    item, refreshAgendaItem, canSave, users
  }) {
    return {
      controller,
      controllerAs: 'editAgendaItemDialogVM',
      locals: {
        item,
        refreshAgendaItem,
        canSave,
        users,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.oversight.editAgendaItemDialog', [
  alerts,
  addAgendaItemNoteDialog,
  agendaItemComment,
  agendaItemDocument,
  agendaItemReport,
  agendaItemFollowup,
  attachAgendaItemDialog,
  constants,
  docDataService,
  loaderService,
  oversightDataService,
  ssDialogService,
])
  .service('editAgendaItemDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('agenda-item-complete-date.messages.html', agendaItemCompleteDateMessagesTpl);
  })
  .name;
